module.exports = __webpack_public_path__ + "ducter_small.svg?fc82030c64e7aedf33a939c4532d743a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ducter_small.svg
// module id = 176
// module chunks = 0